var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3195_2085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "#D9D9D9",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3195_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4875 13.3337V13.3462H7.5H15H15.0125V13.3337V3.33366V3.32116H15H7.5H7.4875V3.33366V13.3337ZM4.16667 16.6795H13.3208V18.3212H4.16667C3.71167 18.3212 3.32249 18.1593 2.99842 17.8352C2.67436 17.5112 2.5125 17.122 2.5125 16.667V5.01283H4.15417V16.667V16.6795H4.16667ZM7.5 14.9878C7.04501 14.9878 6.65582 14.826 6.33176 14.5019C6.00769 14.1778 5.84583 13.7887 5.84583 13.3337V3.33366C5.84583 2.87867 6.00769 2.48948 6.33176 2.16541C6.65582 1.84135 7.04501 1.67949 7.5 1.67949H15C15.455 1.67949 15.8442 1.84135 16.1682 2.16541C16.4923 2.48948 16.6542 2.87867 16.6542 3.33366V13.3337C16.6542 13.7887 16.4923 14.1778 16.1682 14.5019C15.8442 14.826 15.455 14.9878 15 14.9878H7.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.315df2653bd935bbc2d03a9356b6fa5d.svg";
export { ForwardRef as ReactComponent };